/** it expects the redux state */
import { mergeArrays } from '../arraysHelper/index';
import _ from 'lodash';
import eventsFleetConstructor from './mstp_EventsFleet';

const vehiclesConstructor = state => {
  if (state.fleet.fleet.length === 0) {
    return [];
  }
  const events = eventsFleetConstructor(state);
  const vehicleWithEvents = state.fleet.fleet.vehicle.map(vehicle => {
    vehicle.events = events.filter(event => {
      return event.vehicleReference === vehicle.Reference;
    });
    return vehicle;
  });
  return vehicleWithEvents;
};

const vehicleTreeConstructor = (vehicle, disabled = false) => {
  return {
    key: vehicle.Vehicle.Reference,
    pId: vehicle.Vehicle.Traction,
    title: vehicle.Vehicle.Designation,
    value: vehicle.Vehicle.Designation,
    disabled: disabled
  };
};

const fleetConstructor = vehicles => {
  return [...new Set(vehicles.map(element => element.Traction))];
};

const oldFleetConstructor = vehicles => {
  return [...new Set(vehicles.map(element => element.Vehicle.Traction))];
};

const fleetTreeConstructor = (fleetType, disabled = false) => {
  return {
    key: fleetType,
    pId: 0,
    title: fleetType,
    value: fleetType,
    disabled: disabled
  };
};

const oldFleetTreeConstructor = (fleetType, disabled = false) => {
  return {
    key: fleetType,
    pId: 0,
    title: fleetType,
    value: fleetType,
    disabled: disabled
  };
};

const carriageContructor = (vehicles, events = null) => {
  return mergeArrays(
    vehicles.map(vehicle => {
      return vehicle.Carriages.map(carriage => {
        const axleboxes = axleboxContructor(vehicles, events).filter(
          axlebox => {
            if (axlebox) {
              return axlebox.carriageReference === carriage.Reference;
            }
          }
        );
        return {
          reference: carriage.Reference,
          assetKey: carriage.AssetKey,
          designation: carriage.VehicleNumber,
          vehicleReference: vehicle.Reference,
          vehicleDesignation: vehicle.Designation,
          axleboxes,
          fleetDesignation: vehicle.Traction,
          position: carriage.Position
        };
      });
    })
  );
};

const carriageTreeContructor = carriage => {
  return {
    key: carriage.reference,
    pId: carriage.vehicleReference,
    title: carriage.designation,
    value: carriage.designation
  };
};

const axleboxContructor = (vehicles, events = null) => {
  let result = [];
  const wheelsets = mergeArrays(
    vehicles.map(vehicle => {
      return vehicle.Wheelsets;
    })
  );
  const wheelsetsPerCarriage = vehicles.map(vehicle => {
    return vehicle.Carriages.map(carriage => {
      return {
        wheelsetsInCarriage: carriage.Wheelsets,
        carriageReference: carriage.Reference,
        carriageNumber: carriage.VehicleNumber,
        vehicleReference: vehicle.Reference,
        vehicleNumber: vehicle.Designation
      };
    });
  });
  wheelsetsPerCarriage.map(vehicle => {
    vehicle.map(carriage => {
      result = [
        ...result,
        ...mergeArrays(
          wheelsets
            .filter(wheelset => {
              let haveToFilter = false;
              carriage.wheelsetsInCarriage.forEach(wheelsetInCarriage => {
                if (wheelset && wheelset.Reference === wheelsetInCarriage) {
                  haveToFilter = true;
                }
              });
              return haveToFilter;
            })
            .map(wheelset => {
              return wheelset.Axleboxes.map(axlebox => {
                return {
                  reference: axlebox.Reference,
                  assetKey: axlebox.AssetKey,
                  designation: axlebox.LocationName,
                  vehicleReference: carriage.vehicleReference,
                  vehicleDesignation: carriage.vehicleNumber,
                  carriageReference: carriage.carriageReference,
                  carriageDesignation: carriage.carriageNumber,
                  event: [],
                  bearings: axlebox.Bearings,
                  IMEI: axlebox.IMEI
                };
              });
            })
        )
      ];
    });
  });

  wheelsets.forEach(wheelset => {
    //Coordinate 0 is the train, inside that array we have the carriages and the rest of the structure. (Checked in debug mode)
    let carriage = wheelsetsPerCarriage[0].find(
      x => x.wheelsetsInCarriage.indexOf(wheelset.Reference) !== -1
    );

    let Gearbox = wheelset.GearBox;
    if (Gearbox)
      Gearbox = {
        reference: Gearbox.Reference,
        assetKey: Gearbox.AssetKey,
        locationName: Gearbox.LocationName,
        vehicleReference: carriage.vehicleReference,
        vehicleDesignation: carriage.vehicleNumber,
        carriageReference: carriage.carriageReference,
        carriageDesignation: carriage.carriageNumber
      };

    let TractionMotor = wheelset.TractionMotor;
    if (TractionMotor)
      TractionMotor = {
        reference: TractionMotor.Reference,
        assetKey: TractionMotor.AssetKey,
        locationName: TractionMotor.LocationName,
        vehicleReference: carriage.vehicleReference,
        vehicleDesignation: carriage.vehicleNumber,
        carriageReference: carriage.carriageReference,
        carriageDesignation: carriage.carriageNumber
      };

    result.push(Gearbox);
    result.push(TractionMotor);
  });

  if (events) {
    events.forEach(event => {
      result[
        _.findIndex(result, { reference: event.axleboxReference })
      ].event.push(event);
    });
  }

  return result;
};

const axleboxTreeContructor = axlebox => {
  return {
    key: axlebox.reference,
    pId: axlebox.carriageReference,
    title: axlebox.designation,
    value: axlebox.designation
  };
};

const getByDesignation = ({ vehicles, designation }) => {
  const result = vehicles.find(
    vehicle => vehicle.Vehicle.Designation === designation
  );
  return result;
};

const constgetCarriageforBogie = ({ carriages, designation }) => {
  const carriage = carriages.find(
    carriage => carriage.key == designation && carriage.title.length > 3
  );
  const result = { type: 'Carriages', ...carriage };
  return result;
};

const getFleetOrTrainOrCarriageOrBogie = ({
  vehicles,
  carriages,
  reference,
  level
}) => {
  if (level === 'Fleet') return { type: 'Fleets', ...undefined };

  //Checking vehicle
  if (level === 'Train') {
    let vehicle = undefined;
    vehicle = vehicles.find(vehicle => vehicle.Vehicle.Reference === reference);
    if (vehicle) return { type: 'Trains', ...vehicle };
  }

  //Checking carriage
  if (level === 'Carriage') {
    let carriage = undefined;
    carriage = carriages.find(
      carriage => carriage.key === reference && carriage.title.length > 3
    );
    if (carriage) return { type: 'Carriages', ...carriage };
  }

  //Checking bogie
  if (level === 'Bogie') {
    let bogie = undefined;
    bogie = carriages.find(bogie => bogie.key === reference);
    if (bogie) return { type: 'Bogies', ...bogie };
  }

  //Other case
  console.debug('Error: Unexpected value on getVehicleOrCarriage()');
  return { type: 'Error', ...'Unexpected value on getVehicleOrCarriage()' };
};

const getByReferenceOrDesignation = ({
  vehicles,
  reference,
  designation,
  assetKey,
  events = null
}) => {
  const searcher =
    (assetKey && 'assetKey') ||
    (reference && 'reference') ||
    (designation && 'designation') ||
    '';
  if (!searcher) {
    return null;
  }

  const vehicleFound = vehicles.find(
    vehicleSingle =>
      vehicleSingle[searcher.charAt(0).toUpperCase() + searcher.slice(1)] ==
      (reference || designation || assetKey)
  );
  if (vehicleFound !== undefined) {
    return vehicleFound;
  }

  const carriagesFound = carriageContructor(vehicles, events).find(
    carriageSingle => {
      if (carriageSingle[searcher] == (reference || designation || assetKey))
        return carriageSingle;
    }
  );
  if (carriagesFound !== undefined) {
    return carriagesFound;
  }

  const axleboxesFound = axleboxContructor(vehicles, events).find(
    axleboxSingle => {
      if (axleboxSingle[searcher] == (reference || designation || assetKey))
        return axleboxSingle;
    }
  );

  return axleboxesFound || null;
};

/** Use this function inside a .filter() */
const vehiclesWithEventsConstructor = vehicle => {
  return vehicle.events.length > 0;
};

/** Use this function inside a .filter() */
/** TODO: We should remove this duplicate*/
const vehiclesWithEventsConstructorDashboard = vehicle => {
  return vehicle.events.length > 0;
};

export {
  vehiclesConstructor,
  vehiclesWithEventsConstructor,
  fleetConstructor,
  fleetTreeConstructor,
  carriageContructor,
  carriageTreeContructor,
  axleboxContructor,
  axleboxTreeContructor,
  vehicleTreeConstructor,
  getByReferenceOrDesignation,
  getByDesignation,
  vehiclesWithEventsConstructorDashboard,
  oldFleetTreeConstructor,
  oldFleetConstructor,
  getFleetOrTrainOrCarriageOrBogie,
  constgetCarriageforBogie
};
